// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2044":"59e990478b2918b3","4875":"ad2a6c24c59a1269","6412":"33da2c6b273321af","6654":"79c96811e0f7cf0b"}[chunkId] + ".css";
};